import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Snackbar, IconButton, withStyles } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { closeSnackbar } from 'actions/signupForm/addOrEdit'
import styles from './styles'

export default connect(
  state => ({
    snackbar: state.signupForm.addOrEdit.snackbar,
  }),
  dispatch => bindActionCreators({ closeSnackbar }, dispatch)
)(
  withStyles(styles)(({ classes, snackbar, closeSnackbar }) => (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={snackbar.message !== null}
      onClose={closeSnackbar}
      autoHideDuration={snackbar.type === 'success' ? 6000 : null}
      ContentProps={{
        'aria-describedby': 'form-message-id',
        className: 
          snackbar.type === 'error'
            ? classes.snackbarError
            : classes.snackbarSuccess,
      }}
      message={<span id="form-message-id">{snackbar.message}</span>}
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          style={{ padding: 5 }}
          onClick={closeSnackbar}
        >
          <Close />
        </IconButton>,
      ]}
    />
  ))
)
